import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["start", "end", "duration", "file", "fileError", "previewPanel", "previewImage", "fileInfo"];

  connect() {
    this.updateDuration();
  }

  disconnect() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
  }

  updateDuration() {
    const start = new Date(this.startTarget.value);
    const end = new Date(this.endTarget.value);
    if (!this.startTarget.value || !this.endTarget.value) {
      this.durationTarget.textContent = "";
    } else if (end <= start) {
      this.durationTarget.textContent = "结束时间应晚于开始时间";
    } else {
      this.durationTarget.textContent = `预计工时：${((end - start) / 3600000).toFixed(1)} 小时`;
    }
  }

  preview() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = null;
    this.fileErrorTarget.hidden = true;
    this.previewPanelTarget.classList.add("hidden");
    const file = this.fileTarget.files[0];
    if (!file) return;
    if (!["image/jpeg", "image/png", "image/gif", "image/webp"].includes(file.type) || file.size > 50 * 1024 * 1024) {
      this.fileTarget.value = "";
      this.fileErrorTarget.textContent = "请选择不超过 50 MB 的 JPEG、PNG、GIF 或 WebP 图片";
      this.fileErrorTarget.hidden = false;
      return;
    }
    this.previewUrl = URL.createObjectURL(file);
    this.previewImageTarget.src = this.previewUrl;
    this.fileInfoTarget.textContent = `${file.name} · ${(file.size / 1024 / 1024).toFixed(2)} MB`;
    this.previewPanelTarget.classList.remove("hidden");
  }
}
